import SvgLib from '@/components/SvgLib'
import OutlineButton from '@/components/OutlineButton'
import { TimelineMax } from 'gsap'
import { bus } from '@/consts.js'

export default {
  name: 'Assemble',
  template: '#assemble-template',
  components: { SvgLib, OutlineButton },
  data () {
    return {
      introComplete: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      let assembleTl = new TimelineMax()
      assembleTl.fromTo(this.$refs.assembleBg, 1.5, { scale: 1.08 }, { scale: 1 })
      assembleTl.addCallback(() => { this.introComplete = true }, 0.5)
      bus.$emit('closeOverlay')
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/Assemble.js